/**
 * Asynchronously loads the component for PartnerPage
 */

import loadable from 'utils/loadable';

export default loadable(() => import('./ConciergePage'));
